import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { HttpParams } from '@angular/common/http';
import { UntypedFormBuilder } from '@angular/forms';
import { PuntoControlViewModel, PuntoControlItemResultsViewModel } from '../../../../../_mantenimiento/general/puntoscontrol/puntocontrol.types';
import { PuntoControlService } from '../../../../../_mantenimiento/general/puntoscontrol/puntocontrol.service';
import { Table } from 'primeng/table';
import { Dialog } from 'primeng/dialog';
import { Tc } from '../../../../../core/_infrastructure/types/common';
import { GlobalService } from '../../../../../core/_infrastructure/classes/services/global.service';

@Component({
    selector: 'app-punto-control-popup',
    templateUrl: './puntoControlPopup.component.html',
})
export class PuntoControlPopupComponent extends ComponentBase implements OnInit {
    @Output() selected = new EventEmitter<PuntoControlViewModel>();

    @ViewChild('tableSearch') turboTable: Table;
    resultPuntoControl: PuntoControlItemResultsViewModel;
    display = false;
    cols: any[];
    selectedPuntoControl: PuntoControlViewModel | null;
    modoConsulta = false;

    listPais: Tc[];
    IdPais: number | null = null;
    Activo: number;

    public isCollapsed = false;

    constructor(
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private puntoControlService: PuntoControlService,
    ) {
        super();
    }

    ngOnInit() {
        //this.listPais$ = this.globalService.getAllPaisesUeSinSpain(); //Todo:agaro. Cambio a listar los de la UE 29/01/2020
        this.globalService.getPaisesUeSinSpain().subscribe(res => {
            this.listPais = res;
        });

        this.cols = [
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Descripcion', header: 'Compañía' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'IdentificadorTraces', header: 'Identificador Traces' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'Localidad', header: 'Localidad' },
            { field: 'CodigoZip', header: 'Cod. Postal' },
            // { field: 'Activo', header: 'Activo' }
        ];

        this.form = this.fb.group({
            Descripcion: '',
            IdPais: null,
            IdentificadorTraces: '',
            Direccion: '',
            Localidad: '',
            CodigoZip: '',
            Activo: true,
        });
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('Descripcion', this.form.value.Descripcion);
        params = params.append('IdPais', this.IdPais != null ? this.IdPais.toString() : '');
        params = params.append('IdentificadorTraces', this.form.value.IdentificadorTraces);
        params = params.append('Direccion', this.form.value.Direccion);
        params = params.append('Localidad', this.form.value.Localidad);
        params = params.append('CodigoZip', this.form.value.CodigoZip);
        params = params.append('Activo', (this.Activo = 1));
        params = params.append('IsPopup', 'true');

        this.loading = true;

        this.puntoControlService.getPuntoControlPagedByFilter(params).subscribe(result => {
            if (result) {
                this.selectedPuntoControl = null;
                this.resultPuntoControl = result;
                this.loading = false;
            }
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows) {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            Descripcion: '',
            IdPais: this.IdPais,
            IdentificadorTraces: '',
            Direccion: '',
            Localidad: '',
            CodigoZip: '',
            Activo: true,
        });

        this.isCollapsed = false;
    }

    showDialog(idPaisTraslado: number | null, idPuntoControl: number | null): void {
        this.display = true;
        this.selectedPuntoControl = null;

        //Modo buscador
        if (idPaisTraslado != null) {
            this.modoConsulta = false;

            this.IdPais = idPaisTraslado;

            this.form.patchValue({
                IdPais: idPaisTraslado,
            });

            this.form.controls['IdPais'].disable();
        }
        //Si es modo consulta
        else if (idPuntoControl != null) {
            this.modoConsulta = true;
            this.puntoControlService.getPuntoControl(idPuntoControl).subscribe(result => {
                this.selectedPuntoControl = result;

                this.form.setValue({
                    Descripcion: this.selectedPuntoControl.Descripcion,
                    IdPais: this.selectedPuntoControl.IdPais,
                    IdentificadorTraces: this.selectedPuntoControl.IdentificadorTraces,
                    Direccion: this.selectedPuntoControl.Direccion,
                    Localidad: this.selectedPuntoControl.Localidad,
                    CodigoZip: this.selectedPuntoControl.CodigoZip,
                    Activo: this.selectedPuntoControl.Activo,
                });

                this.form.controls['Descripcion'].disable();
                this.form.controls['IdPais'].disable();
                this.form.controls['IdentificadorTraces'].disable();
                this.form.controls['Direccion'].disable();
                this.form.controls['Localidad'].disable();
                this.form.controls['CodigoZip'].disable();
                this.form.controls['Activo'].disable();
            });
        }
    }

    onRowDblClick(event: any, puntoControl: PuntoControlViewModel): void {
        this.display = false;

        this.selected.emit(puntoControl);
    }

    acceptDialog(): void {
        this.display = false;

        this.selected.emit(this.selectedPuntoControl!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    onSelect(selection: PuntoControlViewModel): void {
        this.selectedPuntoControl = selection;
    }

    noAccepted(): boolean {
        return !this.form.valid || this.selectedPuntoControl === null;
    }
}
